import React from "react";
import { Loader2 } from "lucide-react";
import { getNotificationTypeConfig } from "./notificationTypeConfig";

const formatNotificationTime = (createdAt) => {
    if (!createdAt) return "Time unavailable";

    const date = new Date(createdAt);

    if (Number.isNaN(date.getTime())) return "Time unavailable";

    return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const NotificationItem = ({ notification, onClick, isLoading = false }) => {
    if (!notification) return null;

    const { icon: Icon } = getNotificationTypeConfig(notification.type);
    const isUnread = notification.is_read !== true;
    const title = notification.title || "Notification";
    const message = notification.message || "";
    const createdTime = formatNotificationTime(notification.created_at);

    return (
        <button
            type="button"
            onClick={() => onClick?.(notification)}
            disabled={isLoading}
            className={`group flex w-full items-start gap-3 border-b border-slate-200 px-4 py-3 text-left transition-colors last:border-b-0 focus:outline-none focus-visible:bg-indigo-50 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-200 disabled:cursor-wait disabled:opacity-80 ${
                isUnread
                    ? "bg-[#fff7ed]"
                    : "bg-white hover:bg-amber-50/50"
            }`}
        >
            <span
                className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-colors ${
                    isUnread
                        ? "bg-white text-amber-600 ring-1 ring-amber-100"
                        : "bg-slate-100 text-slate-500 group-hover:bg-amber-50 group-hover:text-amber-600"
                }`}
            >
                {isLoading ? (
                    <Loader2
                        size={17}
                        className="animate-spin"
                        aria-hidden="true"
                    />
                ) : (
                    <Icon size={17} aria-hidden="true" />
                )}
            </span>

            <span className="min-w-0 flex-1">
                <span className="flex min-w-0 items-start justify-between gap-3">
                    <span
                        className={`min-w-0 break-words text-sm leading-5 ${
                            isUnread
                                ? "font-semibold text-slate-950"
                                : "font-medium text-slate-800"
                        }`}
                    >
                        {title}
                    </span>
                    {isUnread && (
                        <span
                            className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-amber-500"
                            aria-label="Unread notification"
                        />
                    )}
                </span>

                {message && (
                    <span className="mt-1 block break-words text-sm leading-5 text-slate-600">
                        {message}
                    </span>
                )}

                <span className="mt-2 block text-right text-xs font-medium text-slate-400">
                    {createdTime}
                </span>
            </span>
        </button>
    );
};

export default NotificationItem;
